export const RECENT_SUPPLIER_KEY = venueId =>
  `oms:recentlyConnectedSupplier:${venueId}`

export const isActiveCatalogueSupplier = venueSupplier =>
  venueSupplier?.isActive === true &&
  venueSupplier?.isCatalogueAccessible === true

export const getActiveSupplierTitles = venueSuppliers => {
  const titles = (venueSuppliers || [])
    .filter(isActiveCatalogueSupplier)
    .map(vs => vs.supplierTitle || vs.supplier?.title)
    .filter(Boolean)

  return [...new Set(titles)].sort((a, b) =>
    String(a).trim().localeCompare(String(b).trim()),
  )
}

export const getRecentlyConnectedSupplier = venueId => {
  try {
    return sessionStorage.getItem(RECENT_SUPPLIER_KEY(venueId)) || null
  } catch {
    return null
  }
}
